import { BaseStore } from "../BaseStore";
import { ContextDispatcher } from "../Variables";
import { ContextType } from "../../../Wrap/Constants/Enums/ContextType";
import { IContextAction } from "../ContextActions";
import * as $ from "jquery";

export interface IContextStoreState {
    contextType?: ContextType;
    hierarchyId?: string;
    culture?: string;
    isAdminUser?: boolean;
    urlParams?: { hierarchyId: string; contextType: ContextType }[];
}

export class ContextStoreStatic extends BaseStore<IContextStoreState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ContextDispatcher, (action) => this.onContextDispatch(action));
    }

    protected getDefaultState(): IContextStoreState {
        const $contextSettings = $("[data-javascript-context-settings]");
        const contextType: ContextType = parseInt($contextSettings.data("javascript-context-type") as any);
        const hierarchyId: string = $contextSettings.data("javascript-context-hierarchy-id") as any;
        const culture: string = $contextSettings.data("javascript-context-culture") as any;
        const isAdminUser: string = $contextSettings.data("javascript-context-is-admin") as any;
        return {
            contextType: contextType,
            hierarchyId: hierarchyId,
            culture: culture,
            isAdminUser: isAdminUser != undefined && isAdminUser.toLowerCase() == "true",
            urlParams: [
                { hierarchyId: null, contextType: ContextType.Customer },
                { hierarchyId: null, contextType: ContextType.SubAccount },
                { hierarchyId: null, contextType: ContextType.Account },
                { hierarchyId: null, contextType: ContextType.None },
            ],
        };
    }

    public getContext(): IContextStoreState {
        return this.getState();
    }

    public isLoading(): boolean {
        return false;
    }

    public flushStore(): void {
        this.resetState();
    }

    public getUrlParamsHierarchyId(contextType: ContextType) {
        return this.getState().urlParams.find((ele) => ele.contextType === contextType).hierarchyId;
    }

    private onContextDispatch(contextAction: IContextAction): void {
        const _urlParams = this.getState().urlParams.concat();
        _urlParams.find((ele) => ele.contextType == contextAction.contextType).hierarchyId = contextAction.hierarchyId;
        this.setState({
            hierarchyId: contextAction.hierarchyId,
            contextType: contextAction.contextType,
            urlParams: _urlParams,
        });
    }
}
